module.exports = {
  FE: {
    staging: {
      endpoint: 'https://fse-nonprod-mgmt-frontend.paytm.com',
    },
    qa: {
      endpoint: 'https://fse-qa-mgmt-frontend.paytm.com',
    },
    qa2: {
      endpoint: 'https://fse-qa2-mgmt-frontend.paytm.com',
    },
    qa3: {
      endpoint: 'https://fse-qa3-mgmt-frontend.paytm.com',
    },
    preprod: {
      endpoint: 'https://fse-preprod-mgmt-frontend.paytm.com',
    },
  },
  BE: {
    staging: {
      endpoint: 'https://fse-staging.paytm.com',
    },
    qa: {
      endpoint: 'https://fse-qa.paytm.com',
    },
    preprod: {
      endpoint: 'https://fse-preprod.paytm.com',
    },
    qa3: {
      endpoint: 'https://fse-qa3.paytm.com',
    },
    prod: {
      endpoint: 'https://fse.paytm.com',
    },
  },
};
